
import vwLoginImageDesktop from '../../assets/login/bg_vw.jpg';
import seatLoginImageDesktop from '../../assets/login/bg_seat.jpg';
import seatLoginImageTablet from '../../assets/login/bg_seat_tablet.jpg';
import audiLoginImageDesktop from '../../assets/login/bg_audi.jpg';
import audiLoginImageTablet from '../../assets/login/bg_audi_tablet.jpg';
import cupraLoginImageDesktop from '../../assets/login/bg_cupra.jpg';
import cupraLoginImageTablet from '../../assets/login/bg_cupra_tablet.jpg';

const BRAND_IMAGES = {
  volkswagen: {
    tablet: vwLoginImageDesktop,
    desktop: vwLoginImageDesktop,
  },
  seat: {
    tablet: seatLoginImageTablet,
    desktop: seatLoginImageDesktop,
  },
  audi: {
    tablet: audiLoginImageTablet,
    desktop: audiLoginImageDesktop,
  },
  cupra: {
    tablet: cupraLoginImageTablet,
    desktop: cupraLoginImageDesktop,
  },
};

export default {
  data() {
    return {
      BRAND_IMAGES,
    };
  },

  computed: {
    loginImage() {
      if (this.$q.screen.lt.lg) {
        return this.BRAND_IMAGES[process.env.VUE_APP_BRAND].tablet;
      }

      return this.BRAND_IMAGES[process.env.VUE_APP_BRAND].desktop;
    },
  },
};
